import { FREQUENCY, MEASUREMENT_TYPE, RECO_MODEL_ACTION_TYPE, RECO_MODEL_OBJECTIVE, RECO_MODEL_USER_TYPE }         from "constants/global";
import { USER_ROLE }                from "framework/session/PermissionsManager";
import { API_METHOD }               from "types";
import { APIData, 
         APIResponseData 
       }                            from "types/cms/frontendTypes";

/*==============================================================================
                                 A P I S
==============================================================================*/

export interface Localization {
  locale : string
  title ?: string
  description ?: string
  detail ?: string
  ctaButtonText ?: string
  ctaButtonLink ?: string
  videoLink ?: string
  icon ?: string | number | APIResponseData<'plugin::upload.file'>
  fullImage ?: string | number | APIResponseData<'plugin::upload.file'>
  shortenedImage ?: string | number | APIResponseData<'plugin::upload.file'>
  elongatedImage ?: string | number | APIResponseData<'plugin::upload.file'>
  herImage ?: string | number | APIResponseData<'plugin::upload.file'>
}

export interface RecoScore {
  impact : number
  simplicity : number
}

export interface CreateRecoRequestData {
  fuelType : MEASUREMENT_TYPE[]
  category : string
  title : string
  description : string
  featuredContent : boolean
  program : boolean
  channelPaper : boolean
  channelEmail : boolean
  channelWeb : boolean
  videoLink ?: string
  detail ?: string
  ctaButtonLink ?: string
  ctaButtonText ?: string
  icon ?: string | number | APIResponseData<'plugin::upload.file'>
  fullImage ?: string | number | APIResponseData<'plugin::upload.file'>
  shortenedImage ?: string | number | APIResponseData<'plugin::upload.file'>
  elongatedImage ?: string | number | APIResponseData<'plugin::upload.file'>
  herImage ?: string | number | APIResponseData<'plugin::upload.file'>
  localizations ?: Localization[]
  disabled ?: boolean
  score ?: RecoScore
  frequency ?: FREQUENCY
  userType ?: RECO_MODEL_USER_TYPE
  actionType ?: RECO_MODEL_ACTION_TYPE
  objective ?: RECO_MODEL_OBJECTIVE
  actionSavingsPotential ?: number
  applianceProfileExclusion ?: Record<string, string[]>
  homeProfileExclusion ?: Record<string, string[]>
  ratePlanExclusion ?: any
  ppExclusion ?: any
  insightAssociation ?: any
}

export namespace CreateReco { 

  export type retval = {
    error : {code : string, message : string},
    reco : APIData<'api::recommendation.recommendation'>
  }  
}

export namespace GetRecoForUtility {

  export const method: API_METHOD = "GET";

  export const apiEndpoint = ''

  export type retval = {
    data : {
      draft : APIData<"api::recommendation.recommendation">[]
      published : APIData<"api::recommendation.recommendation">[]
      modified : APIData<"api::recommendation.recommendation">[]
    },
    meta : {
      count : {
        draft : number
        published : number
        modified : number
        disabled : number
      }
    }
  }

  export type params = { 
  }
  
}

export namespace UpdateRecos {

  export const method: API_METHOD = "POST";

  export const apiEndpoint = '/reco/updateAll'

  export type params = {
    utilityDocumentId : string
    data : Partial<APIData<'api::recommendation.recommendation'>>[]
  }

  export type retval = {
    recos : APIData<"api::recommendation.recommendation">[],
    error : Record<string, string>[]
  }
}

export namespace IngestRecos {

  export type retval = {
    recos : APIData<"api::recommendation.recommendation">[],
    error : Record<string, string>[]
  }
}
